import { render, staticRenderFns } from "./tag_management.vue?vue&type=template&id=26218770&scoped=true&"
import script from "./tag_management.vue?vue&type=script&lang=js&"
export * from "./tag_management.vue?vue&type=script&lang=js&"
import style0 from "./tag_management.vue?vue&type=style&index=0&id=26218770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26218770",
  null
  
)

export default component.exports